

const FileStorage = {
  state: {
    repo_id: '',
    repo_path: '',
    files: ''
  },
  mutations: {
    UPDATE_REPO: (state, payload) => {
      //
      state.repo_id = payload.repository_id
      state.repo_path = payload.repository_path

    },
    UPDATE_FILES: (state, payload) => {
      state.files = payload
    },
    PUSH_UPDATE_FILES: (state, payload) => {
      state.files.unshift(payload.file)
    }
    
  },
    
  getters: {
    repoId (state) {
      return state.repo_id
    },
    repoPath (state) {
      return state.repo_path
    },
    files (state) {
      return state.files;
    }
  
  }
}
export default FileStorage
  